module.exports = __webpack_public_path__ + "static/media/55-iveco-mercedes.0ac2bea1.jpg";